module.exports = __webpack_public_path__ + "static/media/mar-2022.f1040364.svg";